export { QRCodeComponent } from './components';
export { QRCodeModule } from './angularx-qrcode.module';
